import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import "../../styles/EditStreak.css";
import openNotification from "components/utils/CustomNotification";

interface StreakLevel {
  streak_level: number;
  min_streak_count: number;
  max_streak_count: number;
  reward_coins: number;
}

interface EditStreakProps {
  level: StreakLevel;
  orgUid: string;
  onClose: () => void;      // to close modal
  onSuccess: () => void;    // after successful update
}

const EditStreak: React.FC<EditStreakProps> = ({ level, orgUid, onClose, onSuccess }) => {
  const location = useLocation();
  const navigate = useNavigate();

  // values passed from navigate()
  //   const { level, orgUid } = location.state as {
  //     level: {
  //       streak_level: number;
  //       min_streak_count: number;
  //       max_streak_count: number;
  //       reward_coins: number;
  //     };
  //     orgUid: string;
  //   };

  const [minCount, setMinCount] = useState(level.min_streak_count.toString());
  const [maxCount, setMaxCount] = useState(level.max_streak_count.toString());
  const [coins, setCoins] = useState(level.reward_coins.toString());


  const beAddress =
    (window as any)._env_?.REACT_APP_API_URL || process.env.REACT_APP_API_URL;
  const sessionUid = localStorage.getItem("session_uid") || "";
  const userUid = localStorage.getItem("user_uid") || "";

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // VALIDATION: Check if fields are empty
    if (!minCount || !maxCount || !coins) {
      openNotification({
        type: "error",
        message: "Please fill in all required fields marked with *",
      });
      return;
    }

    const streakData = {
      streak_level: level.streak_level,
      min_streak_count: parseInt(minCount, 10) || 0,
      max_streak_count: parseInt(maxCount, 10) || 0,
      reward_coins: parseInt(coins, 10) || 0,
    };

    try {
      const response = await axios.put(
        `${beAddress}/api/streak-config`,
        streakData,
        {
          headers: {
            "user-uid": userUid,
          }, withCredentials: true,
        }
      );

      if (response.status === 200 && response.data?.status === "Success") {
        openNotification({
          type: "success",
          message: response.data.message || "Streak updated successfully",
        });
        onSuccess();
      } else {
        openNotification({
          type: "error",
          message: response.data?.data || "Failed to update streak",
        });
      }
    } catch (err: any) {
      console.error("Error updating streak config:", err);
      openNotification({
        type: "error",
        message: err.response?.data?.message || "Error updating streak",
      });
    }
  };

  const blockInvalidChars = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (["e", "E", "+", "-", "."].includes(e.key)) {
      e.preventDefault();
    }
  };

  return (
    <>
      <h2 style={{ textAlign: "center", marginBottom: "20px", fontSize: "22px", fontWeight: "bold", color: "#333" }}>Edit Streak Level {level.streak_level}</h2>
      <form onSubmit={handleSubmit} className="edit-streak-form">
        <label>
          <div className="labelnames">
            Min streak count <span style={{ color: "red" }}>*</span>:
          </div>
          <input
            type="number"
            value={minCount}
            onChange={(e) => setMinCount(e.target.value)}
            onKeyDown={blockInvalidChars}
          />
        </label>

        <label>
          <div className="labelnames">
            Max streak count <span style={{ color: "red" }}>*</span>:
          </div>
          <input
            type="number"
            value={maxCount}
            onChange={(e) => setMaxCount(e.target.value)}
            onKeyDown={blockInvalidChars}
          />
        </label>

        <label>
          <div className="labelnames">
            Reward coins on streak <span style={{ color: "red" }}>*</span>:
          </div>
          <input
            type="number"
            value={coins}
            onChange={(e) => setCoins(e.target.value)}
            onKeyDown={blockInvalidChars}
          />
        </label>

        <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
          <button
            type="button"
            onClick={onClose}
            style={{
              flex: 1,
              backgroundColor: "#f5f5f5",
              color: "#333",
              border: "1px solid #ccc",
              padding: "10px",
              borderRadius: "4px",
              cursor: "pointer"
            }}
          >
            Cancel
          </button>

          <button type="submit" className="edit-submit-btn" style={{ flex: 1 }}>
            Save Changes
          </button>
        </div>
      </form>
    </>
  );
};

export default EditStreak;